import React from 'react'
import PropTypes from 'prop-types'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { GenericHeading } from '../typography/Headings'
import { Paragraph, Overline } from '../typography'

export default function DataBlock({ as = 'div', data, heading, inline = false, dataFocused, dataProps, ...props }) {
  if (dataFocused) {
    return (
      <GenericHeading as={as} size="H6" supplementary {...sanitizeProps(props)}>
        <Overline>{heading}</Overline>
        {data}
      </GenericHeading>
    )
  }

  return (
    <Paragraph size="sm" as={as} dense {...sanitizeProps(props)}>
      <strong>{heading}</strong>
      {inline && data ? ' ' : <br />}
      {data}
    </Paragraph>
  )
}

DataBlock.propTypes = {
  /** Heading to display. (e.g. Birth, Death). It is recommended that you limit JSX in here, so as to keep consistency. */
  heading: PropTypes.node.isRequired,

  /** The text to display. If more than one line is needed, use a `<br />`. It is recommended that you limit JSX in here, so as to keep consistency. */
  data: PropTypes.node.isRequired,

  /** If true, the heading will be on the same line as the data */
  inline: PropTypes.bool,

  /**
   * If true, font-sizing is adjusted to put more visual focus on the data instead of the headings.
   *
   * **NOTE:** This option does not currently work when `inline` is set.
   */
  dataFocused: PropTypes.bool,

  /** HTML tag name for data container. */
  as: PropTypes.string,

  /** Add custom props to the data section container. */
  dataProps: PropTypes.object,
}
